export enum DomainValidationStatus {
    NO_ERROR,
    INVALID_CHARACTERS_ERROR,
    NOT_UNIQUE_ERROR,
    WILDCARD_NOT_LEFTMOST_CHARACTER_ERROR,
    WILDCARD_PERIOD_ERROR,
    DOMAIN_NAME_IS_DEFAULT,
    DOMAIN_NAME_IS_BLOCKED,
    DOMAIN_NAME_MAXIMUM_CHARACTERS
}
